import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { createRequestOption } from '../helpers/request-util';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InfraccionService {

  public resourceUrl = environment.apiUrl + 'comparendo/infraccion';
  constructor(public http: HttpClient) { }

  create(infraccion: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl, infraccion);
  }

  update(infraccion: any): Observable<any> {
    return this.http.put<any>(this.resourceUrl, infraccion);
  }

  find(id: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/${id}`);
  }

  listAll(): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/list_all`);
  }

  allManuales(): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/all_manuales`);
  }

  query(req?: any): Observable<any> {
    const options = createRequestOption(req);
    return this.http.get<any[]>(this.resourceUrl, { params: options });
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.resourceUrl}/${id}`);
  }

  findByDescripcion(descripcion: string, limit: number) {
    if (descripcion === '') {
      return of([]);
    }

    return this.http.get<any[]>(`${this.resourceUrl}/find_by_descripcion?descripcion=${descripcion}&limit=${limit}`)
    .pipe(
      map(response => {
        return response;
      })
    );
  }
}

